import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { clearSundaySchoolSession, getSundaySchoolSession, isSundaySchoolLoggedIn } from './sundaySchoolSession';

export default function SundaySchoolRequireAuth({ children }: { children: ReactNode }) {
  if (!isSundaySchoolLoggedIn()) {
    // 로그인 뒤 교사로 바뀐 계정 등 콘솔을 쓸 수 없는 세션은 지우고 로그인 화면으로.
    if (getSundaySchoolSession()) clearSundaySchoolSession();
    return <Navigate to="/manage-ss/" replace />;
  }
  return <>{children}</>;
}
